<script>
import { mapFilters } from '../filters/map-filters.js'
import { mapGetters } from 'vuex'

export default {
  name: 'product-attributes-chips',
  methods: {
    attributeValue: function (attribute) {
      if (attribute.SelectedValue && attribute.SelectedValue.length > 0) {
        return attribute.SelectedValue
      } else if (attribute.SelectedValueId) {
        var value = attribute.Values.filter((value) => value.Id == attribute.SelectedValueId)
        return value && value.length > 0 ? value[0].Name : attribute.SelectedValueId
      } else {
        return null
      }
    },
    attributeHeadline: function (attribute) {
      // Removed extra setting of time step as the atrribute is arrive as the properly formatted time
      let headline = this.filters.attributeHeadline(this.attributeValue(attribute))
      return headline
    },

    ...mapFilters(['convertToTime']),
  },
  computed: {
    filters: function () {
      return this.$options.filters
    },

    ...mapGetters({
      hiddenAttributes: 'global/hiddenAttributes',
    }),
  },
  render(createElement) {
    return createElement(
      'ul',
      {
        attrs: {
          class: 'attribute-tags',
        },
      },
      this.attributes.map((attr) => {
        if (this.attributeValue(attr) && !attr.IsDisabled && !this.hiddenAttributes.includes(attr.Name)) {
          let attrTitle = attr.IsActivityTime ? this.convertToTime(attr.SelectedValueId) : this.attributeHeadline(attr)
          return createElement(
            'li',
            {
              attrs: {
                title: attrTitle,
              },
            },
            this.attributeHeadline(attr)
          )
        }
      })
    )
  },
  props: ['attributes'],
}
</script>
